<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">机构名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入机构名称"></el-input>
            </div>
            <!-- <div class="item">
                <div class="label">地区:</div>
                <el-cascader
                size="small"
                :options="options"
                v-model="selectedOptions"
                @change="handleRegionChange">
                </el-cascader>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建机构</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="机构名称"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="jianCheng"
                label="分机构简称"
                align="center"
                width="150px"
                >
                </el-table-column>
                <el-table-column
                prop="province"
                label="所属省份"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="所属市级"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="district"
                label="所属片区"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteMechanismTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="600px">
            <div class="dialog">
                <!-- <div class="item" v-if="level==2">
                    <div class="label">
                        分公司/片区:
                    </div>
                    <div class="value">
                        <el-input v-model="parentName" size="small" placeholder="请选择" disabled></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="parentDialog=true">选择分公司/片区</el-button>
                </div> -->
                <div class="item">
                    <div class="label">
                        机构名称
                    </div>
                    <div class="value">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        分机构简称
                    </div>
                    <div class="value">
                        <el-input v-model="addData.jianCheng" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleAddRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否有审核人员:
                    </div>
                    <div class="value">
                        <el-select v-model="addData.isSh" size="small" placeholder="请选择"  class="citem-input">
                            <el-option
                            v-for="item in isShList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        机构负责人:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.mechanismPerson" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件类型:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.documentType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件号码:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.identiNumber" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addMechanism">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="parentDialog" title="选择机构" width="800px">
            <div class="table">
                <el-table
                    :data="tableData"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="name"
                    label="机构名称"
                    align="center"
                    width="250px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="所属省份"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="city"
                    label="所属市级"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="district"
                    label="所属片区"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectParent(scope.row)">选择机构</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCurrentChange"
                        background
                        layout="prev, pager, next, total"
                        :total="totalCount"
                        :current-page="conditionData.page"
                        :page-size="conditionData.pageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑机构" width="600px">
            <div class="dialog">
                <!-- <div class="item" v-if="updateData.parentId" >
                    <div class="label">
                        分公司/片区:
                    </div>
                    <div class="value">
                        <el-input v-model="parentName" size="small" placeholder="请选择" disabled></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="parentDialog=true">选择分公司/片区</el-button>
                </div> -->
                <div class="item">
                    <div class="label">
                        机构名称
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        分机构简称
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.jianCheng" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="district"
                        @change="handleUpdateRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否有审核人员:
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.isSh" size="small" placeholder="请选择"  class="citem-input">
                            <el-option
                            v-for="item in isShList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        机构负责人:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.mechanismPerson" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件类型:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.documentType" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        证件号码:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.identiNumber" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateMechanism">确 定</el-button>
                </div>
            </div>
        </el-dialog>

       
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            selectedOptions:[],
            parentDialog:false,
            district:[],
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                Name:'',
               
                page:1,
                pageSize:10,
            },
            parentName:'',
            addData:{},
            updateData:{},
            tableData:[],
            options:regionData,
            level:1,
            isShList:[{
                label:'否',
                value:false,
            },{
                label:'是',
                value:true,
            }],
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        selectParent(row){
            console.log(row);
            this.addData.parentId = row.id;
            this.updateData.parentId = row.id;
            this.parentName = row.name;
            this.parentDialog = false;
        },
        handleRegionChange(codeArray){
            console.log(codeArray);
            if(codeArray[0]){
                this.conditionData.Province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.conditionData.City = CodeToText[codeArray[1]]
            }
            if(codeArray[2]){
                this.conditionData.Area = CodeToText[codeArray[2]]
            }
        },
        handleUpdateRegionChange(codeArray){
            console.log(codeArray);
            console.log(this.district);
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.cityCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.cityCode = this.updateData.cityCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.district = CodeToText[codeArray[2]]
                this.updateData.cityCode = this.updateData.cityCode + ',' + codeArray[2]
            }
            console.log(this.updateData);

        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.addData.province = CodeToText[codeArray[0]]
                this.addData.cityCode = codeArray[0]
            }
            if(codeArray[1]){
                this.addData.city = CodeToText[codeArray[1]]
                this.addData.cityCode = this.addData.cityCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.addData.district = CodeToText[codeArray[2]]
                this.addData.cityCode = this.addData.cityCode + ',' + codeArray[2]
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.QueryMechanism(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                Name:'',
                
                page:1,
                pageSize:10,
            },
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
            
        },
        async addMechanism(){
            if(!this.addData.province){
                this.addData.Province = '全部'
            }
            if(!this.addData.city){
                this.addData.city = '全部'
            }
            if(!this.addData.district){
                this.addData.district = '全部'
            }
            if(!this.addData.cityCode){
                this.addData.cityCode = ''
            }
            let res  = await api.CreateMechanism(this.addData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
            this.addData = {};
            this.district = [];
        
        },
        
        async updateMechanism(){
            if(!this.updateData.province){
                this.updateData.province = '全部'
            }
            if(!this.updateData.city){
                this.updateData.city = '全部'
            }
            if(!this.updateData.district){
                this.updateData.district = '全部'
            }
            if(!this.updateData.cityCode){
                this.updateData.cityCode = ''
            }
            let res  = await api.UpdateMechanism(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }
            this.updateData = {};
            this.district = [];
        },
        async isUpdateDialogShow(row){
            this.updateData.parentId = null;
            let res  = await api.QuryMechanismById(row.id);
            this.isUpdateDialog = true;
            this.updateData = res.data.data;

            if(this.updateData.district){
                this.district = [TextToCode[this.updateData.province].code,TextToCode[this.updateData.province][this.updateData.city].code,TextToCode[this.updateData.province][this.updateData.city][this.updateData.district].code];
            }else if(this.updateData.city){
                this.district = [TextToCode[this.updateData.province].code,TextToCode[this.updateData.province][this.updateData.city].code,'']
            }else if(this.updateData.province){
                this.district = [TextToCode[this.updateData.province].code,'','']
            }

        },
        deleteMechanismTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteMechanism(row){
            console.log(row.id);
            let res  = await api.deleteMechanism(row.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 100px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
